// These align with the @font-family settings in app/assets/stylesheets/application.css.scss

export default {
  regular: 300,
  bold: 500,
  semibold: 600,
  heavy: 600,
  black: 700
}
